import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
export function HeroTestimonial() {
  return <section className="px-4 pt-2 pb-6" data-id="element-106">
      <motion.div initial={{
      opacity: 0,
      y: 10
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="bg-brand-card-bg border-l-4 border-brand-gold rounded-xl p-4 sm:p-5 max-w-xl mx-auto shadow-sm" data-id="element-107">
        <div className="flex items-center gap-1 text-brand-gold mb-2" data-id="element-108">
          {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 fill-current" data-id="element-109" />)}
        </div>
        <p className="italic text-[14px] sm:text-base text-gray-700 leading-relaxed" data-id="element-110">
          "Die Qualität der Module übersteigt alles, was ich bisher von Siemens
          oder Festo erhalten habe. Endlich Schweizer Industriefälle mit echter
          SPS-Logik, die meine Lernenden wirklich vorbereitet."
        </p>
        <div className="mt-3 text-[12px] sm:text-sm font-bold text-brand-charcoal" data-id="element-111">
          — Ing. Markus R. | Berufsfachschule Zürich | 18 Jahre Erfahrung
        </div>
      </motion.div>
    </section>;
}